module.exports = __webpack_public_path__ + "img/OY0002.86cfb33.webp";